import { render } from "./IconAccessTime.vue?vue&type=template&id=794af504"
import script from "./IconAccessTime.vue?vue&type=script&lang=js"
export * from "./IconAccessTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__